import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';
import { Image } from '@garnish/media';

import { type Props } from '../OrganizationLink.types';

// ─────────────────────────────────────────────────────────────────────────────

export const OrganizationLinkPressable = (props: Props) => {
  const { link, onPress, textStyle } = props;

  return (
    <View style={styles.linkWrapper}>
      <TouchableOpacity accessibilityRole="button" onPress={onPress}>
        <BodyText style={textStyle} sizeMatch={['16']}>
          {link.label}
        </BodyText>
      </TouchableOpacity>

      {link.icon ? (
        <Image
          style={styles.linkIcon}
          aria-label={link.label}
          source={{ uri: link.icon }}
          contentFit="contain"
        />
      ) : null}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  linkWrapper: {
    minHeight: theme.spacing['6'],
    gap: theme.spacing['2'],
    flexDirection: 'row',
    alignItems: 'center',
  },
  linkIcon: {
    width: 32,
    height: 24,
  },
});
